import { render, staticRenderFns } from "./ChannelEcommercePlatformView.vue?vue&type=template&id=53d69ac9&"
import script from "./ChannelEcommercePlatformView.vue?vue&type=script&lang=js&"
export * from "./ChannelEcommercePlatformView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports